'use strict';

var isPlainObject = require('../../../../_virtual/isPlainObject.js_commonjs-exports2.js');
require('../../../prop-types-exact/build/helpers/isPlainObject.js');
var isPlainObject$1 = require('../../../../_virtual/isPlainObject.js_commonjs-module.js');

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isPlainObject = _interopRequireDefault(isPlainObject$1.isPlainObject.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _isPlainObject["default"];
exports["default"] = _default;

}(isPlainObject.__exports));
